import store from '@/store';

export const ensureActiveSubscriptionGuard = async (to, from, next) => {
  const hasFreeTrial = store.getters['subscriptions/hasFreeTrial'];

  hasFreeTrial ? next({ name: 'home' }) : next();
};
